import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import { connect } from "trim-redux";
import {
    FormControlLabel,
    InputAdornment, List,
    ListItem,
    ListItemText,
    MenuItem,
    Switch,
    Typography,
    useMediaQuery
} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../components/elements/LoadingButton";
import { Styles } from '../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {Link, useNavigate} from "react-router-dom";
import FieldCounter from "../../../components/elements/fields/FieldCounter";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import SubTitle from "../../../components/elements/SubTitle";
import {useParams} from "react-router";
import ShopAdminChooser from "./components/ShopAdminChooser";
import {industries, isAdmin} from "../../../../config/Permissions";
import {useTranslation} from "react-i18next";
import RayaField from "../../../components/elements/fields/RayaField";
import {theme} from "../../../../config/design/theme";
import {Alert, AlertTitle} from "@mui/lab";
import {BadgeInfo, CircleCheckBig, CircleX, SquareCheckBig, SquareX} from "lucide-react";
import SignContractDialog from "../../../components/elements/SignContractDialog";
import {currencySymbol, showTableDate} from "../../../../config/values";
import NumberField from "../../../components/elements/fields/NumberField";
import {
    formatPreparationTimeLabel,
    getPreparationTimeOptions,
    PREPARATION_TIME_MINUTES,
    preparationTimeForApi,
} from "../../../../config/shopPreparationTime";

const MakeShop = (props) => {
    const { classes } = props;
    const navigation = useNavigate();
    const { t } = useTranslation();

    let { id } = useParams();
    if(!id && !props.create){
        if(!!props.user.shop){
            id = props.user.shop.id;
        }else{
            navigation('/')
        }
    }
    const [fields, setFields] = useState({
        status: 'pending',
        name: '',
        description: '',
        industry: 'restaurants',
        free_delivery_limit: 0,
        minimum_order: 0,
        preparation_time: 30,
        radius: '',
        commission: '',
        transfer_by: 'system',
    });
    const [shop, setShop] = useState(null);
    const [logo, setLogo] = useState(null);
    const [banner, setBanner] = useState(null);
    const [user_id, setUserId] = useState(null);
    const [owner, setOwner] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [isPopular, setIsPopular] = useState(0);
    const [isEconomic, setIsEconomic] = useState(0);
    const [isPod, setIsPod] = useState(0);
    const [hasFreeDelivery, setHasFreeDelivery] = useState(0);
    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/shops/get/${id}`,config)
            .then(response => {
                setFields({
                    name: response.data.name,
                    status: response.data.status,
                    description: !!response.data.description ? response.data.description : '',
                    free_delivery_limit: !!response.data.free_delivery_limit ? response.data.free_delivery_limit : 0,
                    minimum_order: !!response.data.minimum_order ? response.data.minimum_order : 0,
                    preparation_time: preparationTimeForApi(response.data.preparation_time) || 45,
                    commission: !!response.data.commission ? response.data.commission : '',
                    radius: !!response.data.radius ? response.data.radius : '',
                    industry: !!response.data.industry?.name ? response.data.industry?.name : 'restaurants',
                    transfer_by: !!response.data.transfer_by ? response.data.transfer_by : 'system',
                });
                setShop(response.data)
                setLogo(response.data.logo)
                setBanner(response.data.banner)
                setUserId(response.data.user_id)
                setOwner(response.data.owner)
                setIsPopular(response.data.is_popular)
                setIsPod(response.data.is_pod)
                setHasFreeDelivery(response.data.has_free_delivery)
                setIsEconomic(response.data.is_economic)
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        if(!!id){
            // Fetch match data when component mounts
            loadData();
            setEditMode(true);
        }else{
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        const allowed = getPreparationTimeOptions(fields.industry);
        if (!allowed.includes(Number(fields.preparation_time))) {
            setFields((prev) => ({ ...prev, preparation_time: PREPARATION_TIME_MINUTES.MIN_30 }));
        }
    }, [fields.industry]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const nextValue = name === 'preparation_time' ? preparationTimeForApi(value) : value;
        setFields((prevFields) => ({ ...prevFields, [name]: nextValue }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleField = (input,val) => {
        setFields((prevFields) => ({ ...prevFields, [input] : val }));
        setErrors((prevErrors) => ({ ...prevErrors, [input]: '' }));
    };
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.name)) {
            formIsValid = false;
            newErrors.name = t('emptyField');
        }
        if(!!isAdmin() && !!editMode){
            if(fields.status === "active"){
                if(
                    !shop.has_time ||
                    !shop.has_address ||
                    !shop.product_count ||
                    !shop.menus_count
                ){
                    formIsValid = false;
                    enqueueSnackbar(t('shopCanNotBeActive'), { variant: 'warning' });
                }

                if(!user_id){
                    formIsValid = false;
                    newErrors.owner = t('emptyField');

                }

            }
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {
        const data = new FormData();
        data.append('name', fields.name);
        data.append('status', fields.status);
        data.append('description', fields.description);
        data.append('free_delivery_limit', fields.free_delivery_limit);
        data.append('minimum_order', fields.minimum_order);
        data.append('preparation_time', preparationTimeForApi(fields.preparation_time));
        data.append('industry', fields.industry);
        data.append('radius', fields.radius);
        data.append('commission', fields.commission);
        data.append('transfer_by', fields.transfer_by);
        data.append('logo_id', !!logo ? logo.id : '');
        data.append('banner_id', !!banner ? banner.id : '');
        data.append('is_pod', !!isPod ? 1 : 0);
        data.append('has_free_delivery', !!hasFreeDelivery ? 1 : 0);
        data.append('is_economic', !!isEconomic ? 1 : 0);
        data.append('is_popular', !!isPopular ? 1 : 0);
        if(!!user_id){
            data.append('user_id', user_id);
        }
        if(!!id){
            data.append('id', id);
        }
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            await axios.post(`${defaultVariables.url}/shops/make`, data, config).then(response => {
                enqueueSnackbar(t('detailsSet'), { variant: 'success' });
                setSubmitLoading(false);
                if(!id){
                    if(!!isAdmin()){
                        window.location = (`/panel/manage/shops/edit/${response.data.id}/?tab=address`);
                    }else{
                        window.location = (`/panel/vendor/setting/address`);
                    }
                }

            });


        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 403){
                enqueueSnackbar(t('duplicateShopName'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });

            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };

    if (loading) {
        return <AppCardLoaderFields />;
    }

    return (
        <Grid container spacing={2} justify="center" alignItems="center">
            <CssBaseline />
            <Grid item size={12}>
                <Alert severity="success"  icon={<BadgeInfo className="lucide-large"/>}>
                    {t('writeYouVendorInfoHere')}
                </Alert>
                <div className="d-flex flex-justify-center flex-column-sm" style={{gap:20}}>
                    <div className="imageChooserHolder">
                        <SubTitle align={'left'}>{t('bannerImage')}</SubTitle>
                        <SingleImageChooser
                            primary
                            onChange={(banner) => setBanner(banner)}
                            initial={banner}
                            image_size="s_thumb"
                            width={!!isMobile ? 200 : 400}
                            style={{aspectRatio:2/1}}
                        />
                    </div>
                    <div className="imageChooserHolder">
                        <SubTitle align={'left'}>{t('logoImage')}</SubTitle>
                        <SingleImageChooser
                            primary
                            onChange={(logo) => setLogo(logo)}
                            initial={logo}
                            width={!!isMobile ? 100 : 200}
                            style={{aspectRatio:1}}
                        />
                    </div>
                </div>
            </Grid>

            {
                (!!editMode && !!isAdmin() && !!owner) &&
                <Grid item size={12} className="manage-org-sec">
                    {
                        !!owner &&
                        <Typography>{t('owner')}: <strong>{owner?.first_name} {owner?.last_name}</strong></Typography>
                    }
                </Grid>
            }

            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    label={t('shopIndustry')}
                    name="industry"
                    value={fields.industry}
                    onChange={handleChange}
                    error={!!errors.industry}
                    helperText={errors.industry}
                    select
                >
                    {
                        industries.map((industry,index) =>(
                            <MenuItem key={index} value={industry}>{t(industry)}</MenuItem>
                        ))
                    }
                </RayaField>
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    label={t('shopName')}
                    name="name"
                    value={fields.name}
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                />
            </Grid>

            <Grid item size={12}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={isPod}
                            onChange={() => setIsPod(!isPod)}
                            color="secondary"
                        />
                    }
                    label={t('payOnDelivery')}
                />
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <NumberField
                    fullWidth
                    label={t('minimumOrder')}
                    variant="outlined"
                    value={fields.minimum_order}
                    endAdornment={currencySymbol}
                    decimals={2}
                    min={0}
                    onChange={(res) => handleField('minimum_order', res)}
                    error={!!errors.minimum_order}
                    helperText={!!errors.minimum_order ? errors.minimum_order : t('minimumOrderDescription')}
                />
            </Grid>
            <Grid item size={{xs:12,md:6}}>
                <RayaField
                    variant="outlined"
                    required
                    fullWidth
                    label={t('preparationTime')}
                    name="preparation_time"
                    value={fields.preparation_time}
                    onChange={handleChange}
                    error={!!errors.preparation_time}
                    helperText={!!errors.preparation_time ? errors.preparation_time : t('preparationTimeDescription')}
                    select
                >
                    {getPreparationTimeOptions(fields.industry).map((minutes) => (
                        <MenuItem key={minutes} value={minutes}>
                            {formatPreparationTimeLabel(minutes, t)}
                        </MenuItem>
                    ))}
                </RayaField>
            </Grid>

            <Grid item size={12}>
                <RayaField
                    variant="outlined"
                    multiline
                    fullWidth
                    name="description"
                    label={t('shopDesc')}
                    type="text"
                    id="description"
                    className={classes.inputCtl}
                    rows="4"
                    value={fields.description}
                    onChange={handleChange}
                    error = {!!errors['description']}
                    helperText={errors['description']}
                    slotProps={{
                        input:{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <FieldCounter length={fields.description.length} max={1000}/>
                                </InputAdornment>
                            ),
                        }
                    }}
                />
            </Grid>
            {
                (isAdmin()) &&
                <Grid item size={{xs:12}}>
                    <Grid container spacing={2} className="statusHolder">
                        <Grid item size={{xs:12}}>
                            <SubTitle align="left"><strong>{t('adminOptions')}</strong></SubTitle>
                        </Grid>
                        <Grid item size={{xs:12}}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isPopular}
                                        onChange={() => setIsPopular(!isPopular)}
                                        color="secondary"
                                    />
                                }
                                label={t('isPopular')}
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isEconomic}
                                        onChange={() => setIsEconomic(!isEconomic)}
                                        color="secondary"
                                    />
                                }
                                label={t('isEconomic')}
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={hasFreeDelivery}
                                        onChange={() => setHasFreeDelivery(!hasFreeDelivery)}
                                        color="secondary"
                                    />
                                }
                                label={t('hasFreeDelivery')}
                            />
                        </Grid>
                        <Grid item size={{xs:12,md:6}}>
                            <ShopAdminChooser
                                shop_id={!props.create ? id : null}
                                handleRes={(user) => !!user && setUserId(user.id)}
                                default_id={user_id}
                                error={errors['owner']}
                            />
                        </Grid>
                        <Grid item size={{xs:12,md:6}}>
                            {
                                !!hasFreeDelivery &&

                                <NumberField
                                    fullWidth
                                    label={t('freeDeliveryLimit')}
                                    variant="outlined"
                                    value={fields.free_delivery_limit}
                                    endAdornment={currencySymbol}
                                    decimals={2}
                                    min={0}
                                    onChange={(res) => handleField('free_delivery_limit', res)}
                                    error={!!errors.free_delivery_limit}
                                    helperText={errors.free_delivery_limit}
                                />
                            }
                        </Grid>
                        <Grid item size={{xs:12,md:6}}>
                            <NumberField
                                fullWidth
                                label={t('activityRadius')}
                                variant="outlined"
                                value={fields.radius}
                                min={0}
                                endAdornment={"km"}
                                onChange={(res) => handleField('radius', res)}
                                error={!!errors.radius}
                                helperText={!!errors.radius ? errors.radius : t('keepDefaultTO')}
                            />
                        </Grid>
                        <Grid item size={{xs:12,md:6}}>
                            <NumberField
                                fullWidth
                                label={t('commission')}
                                variant="outlined"
                                value={fields.commission}
                                endAdornment={"%"}
                                min={0}
                                max={100}
                                onChange={(res) => handleField('commission', res)}
                                error={!!errors.commission}
                                helperText={!!errors.commission ? errors.commission : t('keepDefaultTO')}
                            />
                        </Grid>
                        <Grid item size={{xs:12,md:6}}>
                            <RayaField
                                variant="outlined"
                                required
                                fullWidth
                                label={t('transferBy')}
                                name="transfer_by"
                                value={fields.transfer_by}
                                onChange={handleChange}
                                error={!!errors.transfer_by}
                                helperText={errors.transfer_by}
                                select
                            >
                                <MenuItem value="system">{t('system')}</MenuItem>
                                <MenuItem value="shop">{t('vendor')}</MenuItem>
                            </RayaField>
                        </Grid>

                        {
                            !!editMode &&
                            <Grid item size={{xs:12}}>
                                <Grid container spacing={2} justifyContent="center">
                                    <Grid item size={{xs:12,md:10,lg:8}}>
                                        <Grid container spacing={2} className="statusHolder">
                                            <Grid item size={12}>

                                                <Alert severity="info">
                                                    <AlertTitle>{t('informationStatus')}</AlertTitle>
                                                    {t('informationStatusDesc')}
                                                </Alert>
                                                <List dense>
                                                    <ListItem className={`status-indicator ${!!shop.has_address ? "active" : "inactive"}`}>
                                                        {
                                                            !!shop.has_address ?
                                                                <SquareCheckBig className="lucide-icon-secondary lucide-large"/>
                                                                :
                                                                <SquareX className="lucide-icon-primary lucide-large"/>
                                                        }
                                                        <ListItemText
                                                            primary={t('addressIsSet')}
                                                        />
                                                    </ListItem>
                                                    <ListItem className={`status-indicator ${!!shop.has_time ? "active" : "inactive"}`}>
                                                        {
                                                            !!shop.has_time ?
                                                                <SquareCheckBig className="lucide-icon-secondary lucide-large"/>
                                                                :
                                                                <SquareX className="lucide-icon-primary lucide-large"/>
                                                        }
                                                        <ListItemText
                                                            primary={t('timeIsSet')}
                                                        />
                                                    </ListItem>
                                                    <ListItem className={`status-indicator ${!!shop.menus_count ? "active" : "inactive"}`}>
                                                        {
                                                            !!shop.menus_count ?
                                                                <SquareCheckBig className="lucide-icon-secondary lucide-large"/>
                                                                :
                                                                <SquareX className="lucide-icon-primary lucide-large"/>
                                                        }
                                                        <ListItemText
                                                            primary={`${t('totalMenus')} ${!!shop.menus_count && "("+shop.menus_count+")"}`}
                                                        />
                                                    </ListItem>
                                                    <ListItem className={`status-indicator ${!!shop.product_count ? "active" : "inactive"}`}>
                                                        {
                                                            !!shop.product_count ?
                                                                <SquareCheckBig className="lucide-icon-secondary lucide-large"/>
                                                                :
                                                                <SquareX className="lucide-icon-primary lucide-large"/>
                                                        }
                                                        <ListItemText
                                                            primary={`${t('totalProducts')} ${!!shop.product_count && "("+shop.product_count+")"}`}
                                                        />
                                                    </ListItem>
                                                </List>
                                            </Grid>
                                            <Grid item size={12}>
                                                <RayaField
                                                    variant="outlined"
                                                    required
                                                    fullWidth
                                                    label={t('vendorStatus')}
                                                    name="status"
                                                    value={fields.status}
                                                    onChange={handleChange}
                                                    error={!!errors.status}
                                                    helperText={errors.status}
                                                    select
                                                >
                                                    <MenuItem value="active">{t('active')}</MenuItem>
                                                    <MenuItem value="pending">{t('pending')}</MenuItem>
                                                    <MenuItem value="inactive">{t('inactive')}</MenuItem>
                                                </RayaField>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>

            }
            {
                (!!editMode && !!owner?.signed_contract_at) &&
                <Grid item size={{xs:12}} style={{display:"flex",gap:10,alignItems:"center",justifyContent:"space-between",padding:20,backgroundColor:"#f5fdf4",borderRadius:12,}}>
                    <Typography>{t('contractAcceptedAt')}: <strong>{showTableDate(owner.signed_contract_at)}</strong></Typography>
                    <SignContractDialog view industry={fields.industry} />
                </Grid>
            }

            <Grid item size={12}>
                <LoadingButton
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    loading={submitLoading}
                >
                    {t('setDetails')}
                </LoadingButton>
            </Grid>

        </Grid>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(MakeShop));
